import isAbsoluteUrl from './isAbsoluteUrl';

export default (nextStep, history) => {
  if (isAbsoluteUrl(nextStep)) {
    window.location.href = nextStep;
  } else {
    history.push(nextStep);
  }
};
